import _ from 'lodash';
import R, { filter, map } from 'ramda';

import axios from 'axios';

const normalize = data => _.indexBy(data, 'experience_id');
const denormalize = data => _.values(data).filter(exp => Object.keys(exp.challenges).length);

const diffChallengesByKey = (prev, next) =>
  Object.keys(prev).reduce((acc, key) => acc[key] ?  _.omit(acc, [key]) : acc , next)

const pickRootFromExperience = (context, experience) => {
  const inChannel = context.channelId
  if (inChannel) {
    const challenges = experience.challenges[`channels/${context.channelId}`]
    return challenges ? challenges.children : {}
  }

  return experience.challenges
}

const extractNewlyUnlockedChallenges = (context, currentExperience, previousExperience) => {
  if (previousExperience == null) return currentExperience;

  const challenges = diffChallengesByKey(
    pickRootFromExperience(context, previousExperience),
    pickRootFromExperience(context, currentExperience)
  )

  return Object.assign({}, currentExperience, {
    challenges,
    challenge_ids: R.pipe( // ids of top level challenges in the context
      filter(item => item.type !== "challenge"),
      map(v => v.id)
    )(Object.values(challenges))
  });
};

const diff = (context, previousExperiences, currentExperiences) =>
  _.mapValues(currentExperiences, experience =>
    extractNewlyUnlockedChallenges(context, experience, previousExperiences[experience.experience_id])
  );


let url = null;
let baseline;
const apiUrl = window._infl.api.url;

const instance = axios.create({
  baseUrl: apiUrl,
  headers: {
    'X_ORG_ID': window._infl.hub.id
  }
});

const { get } = jwt(instance, axios)

export const init = () => get(apiUrl + '/challenges_available')
  .then(({ data }) => {
    baseline = normalize(data.data);
    url = data.links.next;
  });

export const refresh = (context) => get(url)
  .then(R.pipe(
    ({ data: { data } }) => data,
    normalize,
    normalizedData => diff(context, baseline, normalizedData),
    denormalize
  ))
  .catch(error => {
    if (error.response && error.response.status === 304) return [];
    throw(error);
  });

export default { reset: init, refresh };



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_unlock_notifier.js